module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-map"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.locationData.additional_contact_maps.length) ? _c('div', _vm._l((_vm.locationData.additional_contact_maps), function(additional_contact, index) {
    return _c('div', {
      key: index,
      staticClass: "row mb-50"
    }, [_c('div', {
      staticClass: "col-l-4 col-m-4 col-s-12"
    }, [_c('div', {
      staticClass: "location location-info"
    }, [(additional_contact.hide_get_in_touch_label == false || index == 0) ? _c('h2', {
      staticClass: "location-info__title",
      domProps: {
        "innerHTML": _vm._s(_vm.locationData.contact_person.title)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "location-info__adress",
      domProps: {
        "innerHTML": _vm._s(additional_contact.address)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-l-4 col-m-4 col-s-12"
    }, [_c('div', {
      staticClass: "location location-person"
    }, [_c('div', {
      staticClass: "location-person__image"
    }, [(additional_contact.contact_person.photo.url) ? _c('img', {
      attrs: {
        "src": additional_contact.contact_person.photo.url,
        "alt": "photo"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "location-person__info"
    }, [_c('div', {
      staticClass: "location-person__name"
    }, [_vm._v(_vm._s(additional_contact.contact_person.name))]), _vm._v(" "), _c('div', {
      staticClass: "location-person__position"
    }, [_vm._v(_vm._s(additional_contact.contact_person.position))]), _vm._v(" "), _c('div', {
      staticClass: "location-person__email"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + additional_contact.contact_person.email
      }
    }, [_vm._v(_vm._s(additional_contact.contact_person.email))])]), _vm._v(" "), _c('div', {
      staticClass: "location-person__phone"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + additional_contact.contact_person.phone
      }
    }, [_vm._v(_vm._s(additional_contact.contact_person.phone))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-l-4 col-m-4 col-s-12"
    }, [_c('div', {
      staticClass: "location location-map"
    }, [_c('iframe', {
      staticClass: "location-map__iframe",
      staticStyle: {
        "border": "0"
      },
      attrs: {
        "src": additional_contact.map_link,
        "width": "100%",
        "height": "340",
        "frameborder": "0",
        "allowfullscreen": "allowfullscreen"
      }
    })])])])
  }), 0) : _c('div', [_c('div', {
    staticClass: "row mb-50"
  }, [_c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [_c('div', {
    staticClass: "location location-info"
  }, [_c('h2', {
    staticClass: "location-info__title",
    domProps: {
      "innerHTML": _vm._s(_vm.locationData.contact_person.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "location-info__adress",
    domProps: {
      "innerHTML": _vm._s(_vm.locationData.contact_person.adress)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [_c('div', {
    staticClass: "location location-person"
  }, [_c('div', {
    staticClass: "location-person__image"
  }, [(_vm.locationData.contact_person.photo.url) ? _c('img', {
    attrs: {
      "src": _vm.locationData.contact_person.photo.url,
      "alt": "photo"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "location-person__info"
  }, [_c('div', {
    staticClass: "location-person__name"
  }, [_vm._v(_vm._s(_vm.locationData.contact_person.name))]), _vm._v(" "), _c('div', {
    staticClass: "location-person__position"
  }, [_vm._v(_vm._s(_vm.locationData.contact_person.position))]), _vm._v(" "), _c('div', {
    staticClass: "location-person__email"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.locationData.contact_person.email
    }
  }, [_vm._v(_vm._s(_vm.locationData.contact_person.email))])]), _vm._v(" "), _c('div', {
    staticClass: "location-person__phone"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.locationData.contact_person.phone
    }
  }, [_vm._v(_vm._s(_vm.locationData.contact_person.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "location-person__additional-contact",
    domProps: {
      "innerHTML": _vm._s(_vm.locationData.contact_person.additional_contact_person)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [_c('div', {
    staticClass: "location location-map"
  }, [_c('iframe', {
    staticClass: "location-map__iframe",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": _vm.locationData.map_link,
      "width": "100%",
      "height": "340",
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen"
    }
  })])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.locationData.contact_form)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d6d98de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactMap.vue
// module id = 336
// module chunks = 0